var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("el-input", {
        attrs: { placeholder: _vm.placeholder },
        on: { focus: _vm.initDir },
        model: {
          value: _vm.content,
          callback: function ($$v) {
            _vm.content = $$v
          },
          expression: "content",
        },
      }),
      _c(
        "el-dialog",
        {
          staticClass: "keyword-dialog",
          attrs: {
            visible: _vm.dialogVisible,
            title: "关键词选择",
            width: "1260px",
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.confirmSelection },
                    },
                    [_vm._v("确定（Ctrl+Enter）")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "fixed-header" }, [
            _vm.selectedKeywords.length > 0
              ? _c("div", { staticClass: "selected-container" }, [
                  _c("div", { staticClass: "selected-label" }, [
                    _vm._v("已选中："),
                  ]),
                  _c(
                    "div",
                    { staticClass: "selected-items" },
                    _vm._l(_vm.selectedKeywords, function (kw, idx) {
                      return _c(
                        "el-tag",
                        {
                          key: "selected-" + idx,
                          attrs: { closable: "" },
                          on: {
                            close: function ($event) {
                              return _vm.removeSelected(kw[_vm.filedMap.dCode])
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(kw[_vm.filedMap.dName]) + " ")]
                      )
                    }),
                    1
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "search-container" },
              [
                _c("el-input", {
                  ref: "searchInput",
                  attrs: {
                    placeholder: "输入拼音首字母搜索 (Ctrl+F 聚焦)",
                    size: "medium",
                  },
                  nativeOn: {
                    keydown: function ($event) {
                      return _vm.handleSearchKeydown.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.pinyinCode,
                    callback: function ($$v) {
                      _vm.pinyinCode = $$v
                    },
                    expression: "pinyinCode",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "dicWrap",
              staticClass: "dic-wrap",
              class: { "focus-area": _vm.focusArea === "keywords" },
              attrs: { tabindex: "-1" },
            },
            [
              _vm.levelOneGroups.length > 0
                ? _c(
                    "el-tabs",
                    {
                      class: { "tabs-focus": _vm.focusArea === "tabs" },
                      model: {
                        value: _vm.activeLevelOne,
                        callback: function ($$v) {
                          _vm.activeLevelOne = $$v
                        },
                        expression: "activeLevelOne",
                      },
                    },
                    _vm._l(_vm.levelOneGroups, function (levelOne) {
                      return _c(
                        "el-tab-pane",
                        {
                          key: levelOne.levelOneName,
                          attrs: {
                            label: levelOne.levelOneName,
                            name: levelOne.levelOneName,
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "container" },
                            _vm._l(
                              levelOne.levelTwoGroups,
                              function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: "line-" + index,
                                    staticClass: "dic-item flex flex-row",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "dic-title-con flex align-center mr-10",
                                        style: _vm.labelStyle,
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "dic-title" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.levelTwoName) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "keyword-con flex flex-row align-start items-wrap",
                                      },
                                      _vm._l(item.keywords, function (keyword) {
                                        return _c(
                                          "span",
                                          {
                                            key: keyword.id,
                                            staticClass:
                                              "keyword cursor-pointer",
                                            class: {
                                              selected: _vm.isSelected(
                                                keyword[_vm.filedMap.dCode]
                                              ),
                                              highlighted:
                                                keyword ===
                                                _vm.currentTabKeywords[
                                                  _vm.highlightedIndex
                                                ],
                                            },
                                            staticStyle: {
                                              "white-space": "normal",
                                              "word-break": "break-all",
                                            },
                                            style: _vm.keywordStyle,
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleSelect(keyword)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  keyword[_vm.filedMap.dName]
                                                ) +
                                                " "
                                            ),
                                            _vm.isSelected(
                                              keyword[_vm.filedMap.dCode]
                                            )
                                              ? _c("i", {
                                                  staticClass:
                                                    "el-icon-check selected-icon",
                                                })
                                              : _vm._e(),
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }